import { TextField } from '@mui/material';
import { Field } from 'src/API';
import { FieldInput } from 'src/api/process-module';

interface LinkFieldProps {
  field: FieldInput & Partial<Field>;
  index: number;
  handleFieldChange: (index: number, field: Partial<FieldInput & Partial<Field>>) => void;
  isSubmitting: boolean;
  isUsingExistingField: boolean;
}

export const LinkField = ({ field, index, handleFieldChange, isSubmitting, isUsingExistingField }: LinkFieldProps) => {
  return (
    <>
      <TextField
        fullWidth
        label="Default URL"
        value={field.dataSource || (field as any).properties?.dataSource || ''}
        onChange={(e) => handleFieldChange(index, { dataSource: e.target.value })}
        disabled={isSubmitting || isUsingExistingField}
        helperText="Enter default URL (optional)"
      />
    </>
  );
};
